import { type ReactNode } from "react"
import {
  ChartLine,
  Gear,
  ListChecks,
  Package,
  ShoppingCart,
  Sparkle,
  TShirt,
} from "@phosphor-icons/react"

import { POColumnGroups } from "~/constants/purchaseOrderTable"

export function getSharedGroupIcon(group: string): ReactNode {
  const iconSize = 16
  switch (group) {
    case POColumnGroups.ProductInformation:
      return <TShirt size={iconSize} className="text-fg-muted" />
    case POColumnGroups.OrderQuantities:
      return <ShoppingCart size={iconSize} className="text-fg-muted" />
    case POColumnGroups.MOQAndConstraints:
      return <Gear size={iconSize} className="text-fg-muted" />
    case POColumnGroups.SalesAndForecast:
      return <ChartLine size={iconSize} className="text-fg-muted" />
    case POColumnGroups.AvailabilityAndInventory:
      return <Package size={iconSize} className="text-fg-muted" />
    case POColumnGroups.ExternalData:
      return <Sparkle size={iconSize} className="text-fg-muted" />
    case POColumnGroups.ExternalCollectionData:
      return <TShirt size={iconSize} className="text-fg-muted" />
    default:
      return <ListChecks size={iconSize} className="text-fg-muted" />
  }
}
